import Client from "./Clients/AxiosClient";
const resource = "/api/v1/user/vouchers";

export default {
  getByCode(payload) {
    return Client.post(`${resource}/get`, payload);
  },
};
